module.exports = __webpack_public_path__ + "img/d1.1b59382c.png";